import React from 'react';
import { DefaultProject, ProjectContext } from '../../types/Project';
import { Project } from '../../types/Project';
import { Encoder } from '../../types/Encoder';

const initialValues: ProjectContext = {
  project: DefaultProject,
  setProject: (data: Project) => {
    console.log(data);
  },

  updateEncoder: (encoder: Encoder, properties: Record<string, string | number | boolean>, debounce?: number | undefined) => {
    for (const key in properties) {
      console.log(`${encoder.id} ${key} - ${properties[key]}`);
    }
  },

  updateStream: (properties: Record<string, string | number | boolean>, debounce?: number | undefined) => {
    for (const key in properties) {
      console.log(`${key} - ${properties[key]}`);
    }

    console.log(`debounce: ${debounce}`);
  },

  isAwaitingApiSaveToComplete: false,
};

const ProjectsContext = React.createContext<ProjectContext>(initialValues);

export default ProjectsContext;
